import {
    createBrowserRouter,
    createRoutesFromElements,
    Route,
    Navigate,
} from "react-router-dom";

import Dashboard from "pages/Dashboard";
import CurrentCourses from "pages/Courses/Current";
import PastCourses from "pages/Courses/Past";
import BookaMeeting from "pages/BookaMeeting";
import Profile from "pages/Profile";
import Support from "pages/Support";
import BookMeetingCalendar from "pages/BookMeetingCalendar";
import Layout from "components/Layout";

const Router = createBrowserRouter(
    createRoutesFromElements(
        <Route element={<Layout />}>
            <Route index element={<Navigate to="/home" replace />} />
            <Route path="home" element={<Dashboard />} />
            <Route path="courses/current" element={<CurrentCourses />} />
            <Route path="bookameeting" element={<BookaMeeting />} />
            <Route
                path="bookameeting/:canvasUserId"
                element={<BookMeetingCalendar />}
            />
            <Route path="courses/past" element={<PastCourses />} />
            <Route path="profile" element={<Profile />} />
            <Route path="support" element={<Support />} />
        </Route>,
    ),
);

export default Router;
